module.exports = __webpack_public_path__ + "static/img/investment2.99187afc.png";